import type { ProductImageEntry } from "./types";

const entry = (
  id: string,
  module: string,
  opens: string,
  altSv: string,
  altEn: string,
  showsSv: string,
  showsEn: string,
  provesSv: string,
  provesEn: string,
): ProductImageEntry => ({
  id,
  module,
  area: "schedule",
  opens,
  setup: ["Öppna det sparade DEV-resultatet i Planering"],
  scenario: "S1",
  visual: { variant: 0 },
  text: {
    sv: { alt: altSv, shows: showsSv, proves: provesSv },
    en: { alt: altEn, shows: showsEn, proves: provesEn },
  },
  use: ["pages/Plattform.tsx"],
});

export const CALENDAR_DETAIL_CATALOGUE: readonly ProductImageEntry[] = [
  entry(
    "planning.calendar.full-day",
    "Dagvy",
    "Planering → Kalender → Dag",
    "Dagkalender där dagens och kvällens pass är fyllda med besök",
    "Daily calendar where the day and evening shifts are filled with visits",
    "Följ en hel arbetsdag: varje rad är ett pass med besök, restid och lunch, till bil, cykel eller till fots.",
    "Follow a full working day: each row is a shift with visits, travel and lunch, by car, bicycle or on foot.",
    "Kalendern visar ett ruttoptimerat planeringsresultat där gångrundor utgår från distriktets startpunkt.",
    "The calendar shows a route-optimized planning result where walking rounds start from the district's anchor.",
  ),
  entry(
    "planning.calendar.day",
    "Dagvy",
    "Planering → Kalender → Dag",
    "Dagkalender med medarbetarnas planerade besök",
    "Daily calendar of employees’ planned visits",
    "Följ besökens tider och ordning under dagen.",
    "Follow visit times and order through the day.",
    "Kalendern visar besök som hör till det valda planeringsresultatet.",
    "The calendar shows visits from the selected planning result.",
  ),
  entry(
    "planning.calendar.week",
    "Veckovy",
    "Planering → Kalender → Vecka",
    "Veckokalender med medarbetarnas planerade besök",
    "Weekly calendar of employees’ planned visits",
    "Se hur besöken fördelas över planeringsveckan.",
    "See how visits are arranged across the planning week.",
    "Veckovyn visar det valda planeringsresultatets besök över veckan.",
    "The week view shows visits from the selected planning result across the week.",
  ),
  entry(
    "planning.calendar.client-day",
    "Kundvy",
    "Planering → Kalender → Kundrader → Dag",
    "Dagkalender grupperad per kund",
    "Daily calendar grouped by client",
    "Följ kundernas planerade besök under dagen.",
    "Follow clients’ planned visits through the day.",
    "Kundraderna visar besöken i det valda planeringsresultatet per kund.",
    "Client rows show visits from the selected planning result by client.",
  ),
  entry(
    "planning.details.histogram",
    "Histogram",
    "Planering → Detaljer → Histogram",
    "Histogram över besöksbelastning och skiftkapacitet",
    "Histogram of visit workload and shift capacity",
    "Jämför besöksbelastning med tillgänglig skiftkapacitet per intervall.",
    "Compare visit workload with available shift capacity by interval.",
    "Histogrammet läser besök och kapacitet från kalenderns valda resultat.",
    "The histogram reads visits and capacity from the calendar’s selected result.",
  ),
  entry(
    "planning.details.utilization",
    "Utnyttjande",
    "Planering → Detaljer → Utnyttjande",
    "Kalender med resursers kapacitetsutnyttjande per tidsintervall",
    "Calendar of resource capacity use by time interval",
    "Jämför resursers planerade användning över dagen.",
    "Compare planned resource use across the day.",
    "Vyn visar resursutnyttjande från kalenderns valda resultat.",
    "The view shows resource utilization from the calendar’s selected result.",
  ),
  entry(
    "planning.details.demand",
    "Efterfrågan",
    "Planering → Detaljer → Efterfrågan",
    "Tidsdiagram över efterfrågan, bemanning och kapacitetsgap",
    "Timeline of demand, staffing and capacity gaps",
    "Följ efterfrågan och bemanning över dagens tidsintervall.",
    "Follow demand and staffing across the day’s intervals.",
    "Diagrammet visar efterfrågedata för det valda schemat och resultatet.",
    "The chart shows demand data for the selected schedule and result.",
  ),
  entry(
    "planning.details.metrics",
    "Nyckeltal",
    "Planering → Detaljer → Nyckeltal",
    "Fyra synliga nyckeltal för kalenderns valda planeringsresultat",
    "Four visible metrics for the calendar’s selected planning result",
    "Granska brukartidsandel, tilldelning, otilldelade besök och kontinuitet.",
    "Review client-time share, assigned visits, unassigned visits and continuity.",
    "Panelen visar fyra synliga mått från kalenderns valda lösning.",
    "The panel shows four visible measures from the calendar’s selected solution.",
  ),
  entry(
    "planning.details.metrics-travel",
    "Nyckeltal · restid",
    "Planering → Detaljer → Nyckeltal → Restid",
    "Restidskort för kalenderns valda planeringsresultat",
    "Travel-time card for the calendar’s selected planning result",
    "Granska lösningens redovisade restid i Nyckeltalspanelen.",
    "Review the solution’s reported travel time in the Metrics panel.",
    "Kortet visar restidsvärdet från kalenderns valda lösning.",
    "The card shows the travel-time value from the calendar’s selected solution.",
  ),
  entry(
    "planning.unassigned-visits",
    "Otilldelade besök",
    "Planering → Kalender → Otilldelade besök",
    "Lista över besök som saknar medarbetartilldelning",
    "List of visits without an employee assignment",
    "Öppna listan och granska besöken som saknar tilldelning.",
    "Open the list and review visits without an assignment.",
    "Listan visar otilldelade besök i kalenderns valda planeringsresultat.",
    "The list shows unassigned visits in the calendar’s selected planning result.",
  ),
];
